<template>
    <div class="">
    <div class="rootdiv">

        <topmenu></topmenu>


        <div class="container theme-showcase">

            <div>
                <div style="margin: 15px 0;">
                    <el-page-header @back="goBack" title="Back">
                    </el-page-header>
                </div>

            </div>

            <div style="padding: 15px; border:  1px solid #ccc; margin-bottom: 26px; border-radius: 6px;">
                <div>
                    <div class="mylabel">Visitor Category:</div>
                    <div>
                        <el-select v-model="visitorCateId" size="medium" placeholder="Select" clearable>
                            <el-option v-for="item in catelist" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div>
                    <div class="mylabel">Email Template Type:</div>
                    <div>
                        <el-select v-model="EmailTemplateType" size="medium" placeholder="Select">
                            <el-option label="Invitation" :value="1"></el-option>
                            <el-option label="Confirmation" :value="2"></el-option>
                            <el-option label="Remind" :value="3"></el-option>
                        </el-select>
                    </div>
                </div>

                <div>
                    <div class="mylabel">Subject:</div>
                    <div>
                        <el-input v-model="subject" placeholder="Subject" ></el-input>
                    </div>
                </div>


                <div class="mylabel">Content:</div>
                <div style="border: 1px solid #ccc;">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                        :mode="mode" />
                    <Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig"
                        :mode="mode" @onCreated="onCreated" />
                </div>

                <div>

                    <div class="mylabel" style="font-weight: bold;">Insert: </div>
                    <div style="line-height: 40px; background-color: #f1f1f1; padding: 12px;">
                        <div style="display: flex; margin-bottom: 12px;">
                            <div style="">Qrcode: </div>
                            <div>
                                <el-button @click="insetQr" size="small">Qrcode</el-button>
                            </div>
                            <div style="margin-left: 20px;">
                                <el-input v-model="qrcodewidth"  size="small" type="number" @input="qrcodeWidthChange" placeholder="Qrcode width"></el-input>
                            </div>
                        </div>

                        <div style="display: flex; ">
                            <div>Fields:</div>
                            <div style="">
                                <div v-for="item in fieldlist" :key="item.id"
                                    style="display: inline-block; margin:0 10px 10px 0; ">
                                    <el-button @click="insetFd(item.FieldName)" size="small">{{ item.FieldName
                                    }}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="text-align: center; margin: 20px 0; padding-bottom: 5px;">
                    <el-button type="primary" @click="submit">Save</el-button>
                    <el-button  @click="getSoundCode">Sound code</el-button>
                </div>
            </div>
            <div style="height: 35px;"> </div>
        </div>


        <el-dialog title="Sound code" :visible.sync="SoundCodeDialogVisible">
            <div  style="max-height: 400px; overflow-y: auto;">{{ SoundCode }}</div>
        </el-dialog>


    </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import topmenu from '../home/components/topmenu'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor'
i18nChangeLanguage('en')


const server_url ="http://192.168.31.111/"

export default Vue.extend({
    components: {
        Editor, Toolbar,
        topmenu: topmenu
    },
    data() {
        return {
            id:0,
            subject: '',
            EmailTemplateType: 1,
            visitorCateId: '',
            fieldId: '',
            fieldlist: [],
            catelist: [],
            editor: null,
            html: '',
            qrcodewidth:'',
            toolbarConfig: {},
            editorConfig: { placeholder: 'email content...', MENU_CONF: {
                uploadImage:{
                    base64LimitSize: 10 * 1024, // 10kb
                    // server: server_url+'/api/UploadFile/VisitorUpLoadOneImg?type=510',
                }
            }},
            mode: 'default', // or 'simple'
            SoundCode:'',
            SoundCodeDialogVisible:false,
        }
    },
    methods: {
        getSoundCode(){
            var html = this.editor.getHtml();
            this.SoundCode = html;
            this.SoundCodeDialogVisible = true;
        },
        onSubmit() {
            this.loading = true;
            this.btnDis = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            axios.post('/api/EmailTemp/editTemp',
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    eventId: this.eventId,
                    type: this.EmailTemplateType,
                    visitorCateId: this.visitorCateId,
                    content: this.html,
                    subject: this.subject
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
                    message: 'Success!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.$router.back();
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        submit() {
            if (this.subject == '' || this.subject == undefined) {
                this.$message.error('Please enter subject');
                return;
            }
            this.onSubmit();
        },
        goBack() {
            this.$router.back();
        },

        insetQr() {
            this.editor.insertText('{{Qrcode}}');
        },
        qrcodeWidthChange(){
            
        },
        insetFd(fd) {
            this.editor.insertText('{{' + fd + '}}');
        },

        fieldSelectChange() {
            console.log(this.fieldId);
            // var html = this.editor.getHtml();
            this.editor.insertText('xxx');
            // this.editor.focus();
            // console.log(html);
        },

        loadCate() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Visitor/getCateList',
                {
                    eventId: this.eventId,
                    skip: 0,
                    limit: 1000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadCateSucc)
        },
        loadCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.catelist = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        loadData() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/EmailTemp/getList',
                {
                    eventId: this.eventId,
                    id:this.id,
                    limit:1,
                    skip:0,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                var list = res.list;
                if(list&& list.length>0){
                    var item = list[0];
                    this.visitorCateId = item.visitorCateId;
                    this.EmailTemplateType = item.type;
                    this.subject=item.subject;
                    this.html=item.content;
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadFields() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/getFieldsList',
                {
                    eventId: this.eventId,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadFieldsSucc)
        },
        loadFieldsSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.fieldlist = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
    },
    mounted() {
        const id = this.$route.query.id;
        const eid = this.$route.query.eid;
        console.log(id)
        if (eid != undefined && eid != '') {
            this.eventId = eid;
        }
        if (id != undefined && id != '') {
            this.id = id;
            this.loadData();
        }
        this.loadCate();
        this.loadFields();
        // 模拟 ajax 请求，异步渲染编辑器
        // setTimeout(() => {
        //     this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
        // }, 1500)
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.mylabel {
    line-height: 35px;
    font-size: 16px;
    margin-top: 15px;
}
.rootdiv >>> .topmenuitem:nth-child(7){
    color: #fff;
 background-color: #080808;
}
</style>


// WEBPACK FOOTER //
// src/pages/emailtemp/addemailtemp.vue